import { render, staticRenderFns } from "./IpqcDailyList.vue?vue&type=template&id=68a37f44&"
import script from "./IpqcDailyList.vue?vue&type=script&lang=js&"
export * from "./IpqcDailyList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports